import { POST } from './utils';

export async function changeBillingAddressCountry(articleId, country): Promise<any> {
    return POST(`/articles/${articleId}/combinedFlow/changeBillingAddressCountry`, { country: country ?? null });
}

export async function saveForLater(articleId, order): Promise<any> {
    return POST(`/articles/${articleId}/combinedFlow/saveForLater`, order);
}
